import React from 'react'
import './css/Footer.css';

function Footer() {
    return (
        <div className="footer">

            <h1> Made with <img className="heart" src="https://img.icons8.com/stickers/50/000000/like.png" alt="img" /> by Shamik & Mridul </h1>
            
        </div>
    )
}

export default Footer
